<template>
  <div class="content flex-box vertical" v-if="activity">
    <div class="data-title">
      <div class="title-left flex-box">
        <span>共{{pagination.total}}条记录</span>
      </div>
      <a-form-model class="query-form" layout="inline">
        <a-form-model-item label="身份">
          <a-select
            placeholder="请选择身份筛选"
            @change="getList"
            :options="guestTypeList"
            v-model="form.type"
            style="width: 200px">
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="分配状态">
          <a-select
            placeholder="选择分配状态筛选"
            @change="getList"
            :options="statusList"
            v-model="form.status"
            style="width: 200px">
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="">
          <a-input v-model="form.name" placeholder="输入姓名查询" @keyup.enter="getList" style="width: 200px"></a-input>
        </a-form-model-item>
      </a-form-model>
      <a-space class="title-btn">
        <a-button @click="getList">查询</a-button>
        <a-button type="primary" @click="sendSms" v-if="editable">发送短信</a-button>
      </a-space>
    </div>
    <div class="data-area">
      <a-table
        ref="dataTable"
        row-key="id"
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :pagination="pagination"
        :row-selection="rowSelection"
        @change="handleTableChange">
        <template v-slot:action="text, record">
          <div class="row-btn">
            <entity-picker
              :value="record.hotelStatus && record.hotelStatus.hotelRoom ? [record.hotelStatus.hotelRoom] : []"
              url="/activity/activity-hotel-room"
              name-key="type"
              :modal-width="1200"
              :query="`&expand=hotel,hotelAllocation&filter[activity_id]=${activity.id}`"
              :columns="roomColumns"
              @change="handleHotelRoomChange($event, record)"
              style="display: inline-block">
              <a class="txt-btn">{{record.hotelStatus ? '更换规格' : '分配住宿'}}</a>
            </entity-picker>
            <a class="txt-btn" @click.stop="cancelHotelRoom(record)" style="margin-left: 8px;" v-if="record.hotelStatus">取消住宿</a>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
    import entityPicker from "../../../components/form/entity-picker";
    import {roomColumns} from "../../../common/activity/stay";
    import {getGuestTypeText, guestTypeList} from "../../../common/activity/guest";
    import mixins from "../mixins";

    export default {
        name: "StayAssignInfo",
        components: {
            entityPicker
        },
        data() {
            return {
                loading: false,
                list: [],
                form: {},
                h: 500,
                roomColumns,
                pagination: {
                    total: 0,
                    current: 1,
                    pageSize: 10,
                    showSizeChanger: true
                },
                guestTypeList: [{key: 0, title: '所有身份'}].concat(guestTypeList),
                statusList: [
                    {key: 0, title: '全部'},
                    {key: 1, title: '已分配'},
                    {key: 2, title: '未分配'}
                ],
                guest: null,
                meal: null,
                visible: false,
                moduleKey: 'stay-info',
                selectedRows: []
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.$route.meta.action;
            },
            activity() {
                return this.$store.getters.activity;
            },
            selectedRowKeys() {
                return this.selectedRows.map(item => item.id)
            },
            rowSelection() {
                return this.editable ? {
                    selectedRowKeys: this.selectedRowKeys,
                    onChange: this.onSelectChange,
                    getCheckboxProps: this.getCheckboxProps} : null
            },
            columns() {
                const res = [
                    {title: '姓名', dataIndex: 'name'},
                    {title: '手机号', dataIndex: 'tel'},
                    {title: '住宿需求', dataIndex: 'eat_info', customRender: text => text || '无'},
                    {title: '身份标识', dataIndex: 'guestImg', customRender: (text, record) => text ? text.level: getGuestTypeText(record.type)},
                    {title: '分配状态', dataIndex: 'hotelStatus', customRender: text => text ? '已分配' : '未分配'},
                    // {title: '房间号', dataIndex: 'room_num', customRender: (text, record) => record.hotelStatus && record.hotelStatus.room_num  ? record.hotelStatus.room_num : '未分配'},
                ]
                if(this.editable) {
                    res.push({title: '操作', key: 'action', fixed: 'right', width: 180, scopedSlots: { customRender: 'action'}});
                }
                return res
            },
        },
        watch: {
            activity() {
                this.getList();
            }
        },
        created() {
            this.getList();
        },
        mounted() {
            this.setHeight();
            window.addEventListener("resize", this.setHeight, false);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.setHeight, false);
        },
        methods: {
            sendSms() {
                const list = this.selectedRows.filter(item => item.hotelStatus);
                if(list.length > 0) {
                    this.$confirm({
                        title: `确定给下列${list.length}人发送住宿分配短信吗？`,
                        content: <div>{list.map(g => g.name).join("、")}</div>,
                        onOk: () => {
                            const url = "/activity/activity-hotel-allocation/send-msg";
                            this.$axios({
                                url,
                                method: 'POST',
                                data: {
                                    id: list.map(item => item.hotelStatus.id).join(",")
                                }
                            }).then(res => {
                                if(res.error == 0) {
                                    this.$message.success('已发送');
                                    this.getList();
                                } else {
                                    this.$message.warning(res.msg || '发送失败');
                                }
                            });
                        },
                    });
                } else {
                    this.$message.warning("请选择嘉宾");
                }
            },
            onSelectChange(keys, rows) {
                this.selectedRows = rows;
            },
            getCheckboxProps(record) {
                return {
                    props: {
                        disabled: !record.hotelStatus
                    }
                }
            },
            handleHotelRoomChange(room, guest) {
                if(guest.hotelStatus && guest.hotelStatus.room_id == room.id) {
                    return;
                }
                let url = `/activity/activity-hotel-allocation`, method = 'POST';
                const data = {
                    room_id: room.id
                }
                if(guest.hotelStatus) {
                    url += `/${guest.hotelStatus.id}`;
                    method = "PATCH";
                } else {
                    data.activity_id = guest.activity_id;
                    data.guest_id = guest.id;
                }
                this.$axios({
                    url,
                    method,
                    data
                }).then(() => {
                    this.$message.success("已分配");
                    this.getList();
                });
            },
            cancelHotelRoom(item) {
                if(item.hotelStatus) {
                    this.$confirm({
                        title: "提示",
                        content: `确定取消${item.name}的住宿吗？`,
                        onOk: () => {
                            let url = `/activity/activity-hotel-allocation/${item.hotelStatus.id}`;
                            this.$axios({
                                url,
                                method: "DELETE",
                            }).then(() => {
                                this.$message.success("已取消");
                                this.getList();
                            });
                        },
                        onCancel: () => {},
                    });
                }
            },
            handleTableChange(pagination) {
                let pager = { ...this.pagination };
                pager.current = pagination.current;
                pager.pageSize = pagination.pageSize;
                this.pagination = pager;
                this.getList();
            },
            getList() {
                if(!this.activity || this.loading) return;
                this.loading = true;
                const id = this.activity.id;
                let {current, pageSize} = this.pagination;
                let url = `/activity/activity-guest?page=${current}&pageSize=${pageSize}&expand=hotelStatus,guestImg&filter[activity_id]=${this.activity.id}`;
                const form = this.form;
                if(form.type && form.type > 0) {
                    url += `&filter[type]=${form.type}`;
                }
                if(form.name) {
                    url += `&filter[name][like]=${form.name}`;
                }
                if(form.status > 0) {
                    url += `&filter[activity_hotel_allocation.activity_id]=${id}&hotel_status=1&is_allo=${form.status == 1 ? 1 : 0}`;
                }
                this.$axios(url, {noTempleFilter: true}).then(res => {
                    this.dealList(res.data);
                    this.$set(this.pagination, 'total', res.page.totalCount);
                }).finally(() => {
                    this.loading = false;
                });
            },
            dealList(list) {
                this.list = list;
            },
            setHeight() {
                let dataTale = this.$refs.dataTable;
                if(dataTale) {
                    let area = this.$el.querySelector(".data-area");
                    this.h = area.clientHeight - 54 - 64;
                }
            },
        }
    }
</script>

<style scoped>

</style>
